import React from "react";
import SeoArticlePage from "../components/SeoArticlePage";

export default function GestionADistance() {
  return (
    <SeoArticlePage
      seo={{
        title: "Gestion locative à distance : déléguez à un référent local | 360immoinvest",
        description:
          "Gérez votre bien à distance sans agence : un référent local réalise vos états des lieux, remises de clefs et visites. Suivez tout depuis l'application.",
        path: "/gestion-locative-a-distance",
        testid: "seo-distance-page",
      }}
      eyebrow="Gestion à distance"
      h1="Gérer sa location à distance, sans agence"
      intro="Vous possédez un bien loin de chez vous ? Pas besoin de confier toute la gestion à une agence coûteuse. Avec 360immoinvest, vous pilotez votre location en ligne et déléguez uniquement les déplacements à un référent local, près de votre bien."
      sections={[
        {
          title: "Le défi de la gestion à distance",
          paragraphs: [
            "Gérer un logement situé dans une autre ville pose surtout un problème pratique : qui se rend sur place pour l'état des lieux, la remise des clefs ou une visite ? Confier l'ensemble de la gestion à une agence revient cher (souvent 6 à 8 % des loyers), pour des tâches que vous pourriez piloter vous-même.",
            "La solution : garder la main sur l'administratif en ligne, et ne déléguer que les interventions physiques.",
          ],
        },
        {
          title: "Le référent local : votre relais sur le terrain",
          paragraphs: [
            "Le référent local est un intervenant de confiance, près de votre bien, à qui vous confiez ponctuellement les missions qui nécessitent une présence. Agent, artisan, retraité ou auto-entrepreneur, il est sélectionné et évalué après chaque mission.",
            "Vous ne payez que les missions dont vous avez besoin, quand vous en avez besoin — sans mandat de gestion à l'année.",
          ],
        },
        {
          title: "Les missions que vous pouvez déléguer",
          bullets: [
            "États des lieux d'entrée et de sortie",
            "Remise et récupération des clefs",
            "Visites du logement lors d'une relocation",
            "Présence pour des travaux ou un constat",
            "Présence lors d'une assemblée de copropriété (syndic)",
          ],
        },
        {
          title: "Comment ça marche ?",
          bullets: [
            "Vous publiez une mission depuis l'application en précisant le bien et la date souhaitée",
            "Un référent local proche accepte la mission et coordonne le rendez-vous avec le locataire",
            "Il réalise l'intervention et dépose le compte rendu (état des lieux, photos) dans l'application",
            "Vous suivez tout à distance et le paiement est sécurisé via la plateforme",
          ],
        },
        {
          title: "Tout le reste se pilote en ligne",
          paragraphs: [
            "Quittances, suivi des loyers, révision IRL, régularisation des charges et préparation de la déclaration des revenus fonciers : vous gérez tout depuis votre espace, où que vous soyez. Le référent local ne prend en charge que ce qui exige une présence physique.",
          ],
        },
      ]}
      faq={[
        { q: "Est-ce moins cher qu'une agence ?", a: "Oui. Vous ne payez que les missions ponctuelles réalisées par le référent, sans mandat de gestion annuel ni pourcentage sur les loyers." },
        { q: "Les référents sont-ils fiables ?", a: "Les référents sont sélectionnés puis évalués après chaque mission. Vous consultez leur profil et leurs avis avant de confier une intervention." },
        { q: "L'état des lieux réalisé par un référent a-t-il une valeur légale ?", a: "Oui. Le constat est partagé et signé numériquement dans l'application ; il a la même valeur qu'un état des lieux classique." },
        { q: "Puis-je utiliser le référent pour un seul besoin ponctuel ?", a: "Tout à fait. Vous déléguez une mission unique (par exemple un état des lieux de sortie) sans aucun engagement." },
      ]}
      related={[
        { to: "/blog/etat-des-lieux-guide-complet", label: "État des lieux : le guide complet" },
        { to: "/tarifs", label: "Voir les tarifs" },
        { to: "/blog", label: "Le blog du bailleur" },
      ]}
    />
  );
}
